import { type FC, type PropsWithChildren } from 'react'
import classNames from 'classnames'
import { Button } from '../../../components/Button/Button'

interface ExistingPartyRowProps extends PropsWithChildren {
  heading: string
  subheading?: string
  source?: string
  noReview: string
  expanded?: boolean
  onToggleExpand?: () => void
}

export const ExistingPartyRow: FC<ExistingPartyRowProps> = ({ heading, subheading, source, noReview, expanded = false, onToggleExpand, children }) => (
  <div className='rounded-3 p-3 d-flex flex-column zocks-gap-1.5 border zocks-border-color-gray-300'>
    <div className='d-flex align-items-center zocks-gap-1.5'>
      <div className='d-flex flex-column zocks-gap-0.5'>
        <div className='d-flex align-items-center zocks-gap-0.5'>
          <i className='bi bi-person' />
          <span className='paragraph-medium medium'>{heading}</span>
        </div>
        {subheading ? (
          <div className='d-flex align-items-center zocks-gap-0.5'>
            <i className='bi bi-diagram-3 zocks-text-gray-600' />
            <span className='paragraph-medium zocks-text-gray-600'>{subheading}</span>
          </div>
        ) : null}
      </div>
      <div className='d-flex flex-column zocks-gap-0.25 flex-fill'>
        {source ? <span className='paragraph-small zocks-text-gray-600'>{source}</span> : null}
        <span className='paragraph-small zocks-text-gray-600'>{noReview}</span>
      </div>
      {onToggleExpand ? (
        <Button variant='secondary' className='d-flex align-items-center zocks-gap-0.5 flex-shrink-0' onClick={onToggleExpand}>
          <i className={classNames('bi', expanded ? 'bi-x-lg' : 'bi-eye')} />
          {expanded ? 'Close' : 'View'}
        </Button>
      ) : null}
    </div>

    {expanded && onToggleExpand ? <div className='d-flex flex-column zocks-gap-1'>{children}</div> : null}
  </div>
)
